
<div class="post-view">
  <template v-if="loaded && post">
    <header>
      <h3>
        {{ post.title }}
      </h3>

      <align small-gap>
        <icon-button
          v-if="isStaff"
          icon="edit"
          @click="edit"
        />

        <icon-button
          tooltip="Close card"
          icon="close"
          @click="close"
        />
      </align>
    </header>

    <div class="post-content">
      <div class="subtitle">
        <div>Posted {{ $filters.datetime(post.date) }}</div>
        <div v-if="post.creator">
          {{ post.creator }}
        </div>
      </div>

      <p v-if="post.image" class="image">
        <img :src="post.image" />
      </p>

      <section class="body">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <p v-html="post.body" />

        <section
          v-if="post.cardNotes && post.cardNotes.length > 0"
          class="card-notes"
        >
          <template v-if="post.category === 'Headline'">
            <card-note
              v-for="(cardNote, i) in post.cardNotes"
              :key="i"
              as="router-link"
              :to="`/card/${cardNote.card}`"
              target="_blank"
              :card-note="cardNote"
            />
          </template>

          <template v-else>
            <card-list-item
              v-for="(cardNote, i) in post.cardNotes"
              :key="i"
              as="router-link"
              target="_blank"
              :to="`/card/${cardNote.card}`"
              :card="cardNote"
            />
          </template>
        </section>
      </section>
    </div>
  </template>

  <spinner v-else />
</div>
